import { SVGProps } from 'react';
export const PragmaticPlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={props.className}>
    <path
      d="M18.2644 13.6757C15.1609 13.8571 16.5402 18.148 19.9885 17.9063C23.3793 17.6646 21.5977 13.434 18.2644 13.6757Z"
      fill="white"
    />
    <path
      d="M17 11.0165C11.4828 11.0165 7 15.7306 7 21.5325C7 27.3344 11.4253 32.1089 17 32.1089C22.5747 32.1089 27 27.3948 27 21.5929C27 15.7306 22.5172 11.0165 17 11.0165ZM17 31.021C12.0575 31.021 8.03449 26.7905 8.03449 21.5929C8.03449 16.3954 12 12.1648 17 12.1648C21.9425 12.1648 25.9655 16.3954 25.9655 21.5929C25.9655 26.7905 21.9425 31.021 17 31.021ZM16.6552 3.70372C14.2989 5.57725 14.7011 8.4782 14.7011 8.4782C14.7011 8.4782 13.2069 4.36852 11.2529 1.89062C11.023 5.09376 11.9425 9.32431 11.9425 9.32431C11.9425 9.32431 10.7356 6.72555 7.74713 6.54424C10.2184 8.05515 11.1954 10.7144 11.4253 11.4396C12.9195 10.4726 14.5862 9.92868 16.3103 9.86824C16.1379 9.26388 15.3908 6.42336 16.6552 3.70372Z"
      fill="white"
    />
    <path
      d="M10.1609 22.6203V24.7961H9.29885V19.115H11.1379C11.7701 19.115 12.2299 19.2963 12.5172 19.5985C12.8046 19.9007 12.977 20.3238 12.977 20.8677C12.977 21.4116 12.8046 21.8347 12.5172 22.1369C12.1724 22.439 11.7126 22.6203 11.1379 22.6203H10.1609ZM12.1149 20.8677C12.1149 20.5655 12.0575 20.3238 11.8851 20.1424C11.7126 19.9611 11.4253 19.9007 11.0805 19.9007H10.2184V21.8347H11.0805C11.7701 21.8347 12.1149 21.5325 12.1149 20.8677ZM14.5287 24.0708H16.4253V24.7961H13.6667V19.115H14.5287V24.0708ZM20.3908 23.5873H18.092L17.6897 24.7961H16.7701L18.7816 19.1755H19.7586L21.7126 24.7961H20.7931L20.3908 23.5873ZM20.1034 22.8621L19.2414 20.2029L18.3793 22.8621H20.1034ZM25.2184 19.115L23.4368 22.7412V24.7961H22.5747V22.7412L20.7931 19.115H21.7701L23.0345 21.7138L24.2988 19.115H25.2184Z"
      fill="white"
    />
  </svg>
);
